import { AiFillCaretDown, AiFillCaretUp, AiOutlineHome } from "react-icons/ai";
import { SidebarItem } from "../models/SidebarItem";

export const SidebarData_Fa23: SidebarItem[] = [
    {
        title: 'Welcome',
        path: '/fa23/intro'
    },
    {
        title: 'Variables, Functions, Control',
        path: '/fa23/fundamentals'
    },
    {
        title: 'Control Review, Environments',
        path: '/fa23/env'
    },
    {
        title: 'Higher-Order Functions, Lambdas',
        path: '/fa23/hof'
    },
    {
        title: 'Higher-Order Environments, Currying',
        path: '/fa23/hoe'
    },
    {
        title: 'Recursion',
        path: '/fa23/recursion'
    },
    {
        title: 'Tree Recursion',
        path: '/fa23/tree-recursion'
    },
    {
        title: 'Sequences',
        path: '/fa23/seq'
    },
    {
        title: 'ADTs, Trees',
        path: '/fa23/tree-adt'
    },
    {
        title: 'Mutability',
        path: '/fa23/mutability'
    },
    {
        title: 'Iterables, Iterators',
        path: '/fa23/iter'
    },
    {
        title: 'Generators',
        path: '/fa23/gen'
    },
    {
        title: 'OOP, Inheritance, Representation',
        path: '/fa23/oop'
    },
    {
        title: 'Mutable Trees, Linked Lists',
        path: '/fa23/trees-links'
    },
    {
        title: 'Efficiency',
        path: '/fa23/efficiency'
    },
    {
        title: 'Scheme Intro',
        path: '/fa23/scheme'
    },
    {
        title: 'Scheme Lists',
        path: '/fa23/scheme-lists'
    },
    {
        title: 'Interpreters',
        path: '/fa23/interpreters'
    },
    {
        title: 'Programs as Data, Macros',
        path: '/fa23/pad-macros'
    },
    {
        title: 'SQL',
        path: '/fa23/sql'
    }
];
